<template>
  <div class='exploitable-table-cell' @click='() => { $emit("click") }'>
    <div class='not-exploitable' v-if='!item[category.field]'>
      {{ exploitedValue }}
    </div>
    <div class='exploitable' v-else>
      <span class='exploitable-value'> {{ exploitedValue }} </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExploitableTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    exploitedValue() {
      return this.item[this.category.field] ? this.$t('technology.exploited') : this.$t('technology.not.exploited');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.exploitable-table-cell {
  color: var(--text-primary);
  font-family: $font-family-regular;
  font-size: $font-size-base;
  font-weight: bold;
  letter-spacing: 0;
  line-height: rem(17);
  .exploitable {
    display: flex;
    align-items: center;
    .exploitable-value {
      margin-right: rem(19);
    }
    .initiate-action-section {
      z-index: 3;
      align-items: center;
      display: flex;
      justify-content: center;
      min-width: $space-8;
      min-height: $space-8;
      background-color: rgba(179,49,207,0.2);
      border-radius: $radius-md;
      box-shadow: $shadow-xs;
      .material-icons {
        transform: scaleX(-1);
        color: #B331CF;
        font-size: $font-size-lg;
        user-select: none;
      }
      &:hover {
        cursor: pointer;
        border: $border-width-thin solid rgba(179,49,207,0.3);
      }
      &:active{
        border: $border-width-thin solid #B331CF;
      }
    }
  }
  .not-exploitable {
    opacity: 0.3;
  }
}
</style>
